import DetailsAbsenteeism from "./detailsAbsenteeism";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  patient:any
  onClose: Function
};

const DetailsAbsences= ({ toggleModal, urlTittle, patient, onClose }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold my-6";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={`Detalle de ausentismo`}
        titleStyle={styles}
        urlTittle={urlTittle}
        onClose={()=> onClose?.()}
        
      >
        <DetailsAbsenteeism
        patient={patient}
        />
      </Modal>
    </>
  );
};

export default DetailsAbsences;
